import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Card from "components/card";
import SectionHeader from "components/section/SectionHeader";
import { connect } from "react-redux";
import { getTrainingClassDetails } from "../../../redux/trainingclass/trainingClassState";
import TrainingClassTab from "./components/TrainingClassTab";
import { useLocation } from "react-router-dom";

const ViewTrainingClass = ({ getRecord, recordData }) => {
  const { classeId } = useParams();
  const location = useLocation();

  let startTab = "details"; 
	if (location.pathname.includes("/training-class-modules")) startTab = "modules";
	else if (location.pathname.includes("/training-class-participants")) startTab = "participants";
  else if (location.pathname.includes("/training-class-results")) startTab = "results";

  useEffect(() => {
      getRecord(classeId);
  }, [classeId, getRecord]);

  return (
    <div className="mt-3">
      <div className="mt-5 grid h-full grid-cols-1 gap-4">
        <Card extra={"w-full h-full p-4"}>
          <div className="content-wrapper p-5 mb-2 rounded-lg shadow-md">
            <SectionHeader title={recordData?.tcl_title || "Training Class"} />
          </div>
		      <TrainingClassTab recordId={classeId} startTab={startTab} />
        </Card>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordData: state.trainingClass.trainingClassDetails.data,
});

const mapDispatchToProps = (dispatch) => ({
  getRecord: (id) => dispatch(getTrainingClassDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewTrainingClass);
